









































import { defineComponent, ref, useContext } from '@nuxtjs/composition-api';
import { SfButton, SfInput } from '@storefront-ui/vue';

import SvgImage from '~/components/General/SvgImage.vue';
import { useNewsletter } from '~/composables';
import { useUiNotification } from '~/composables/useUiNotification';

export default defineComponent({
  name: 'Subscription',
  components: {
    SfInput,
    SfButton,
    SvgImage,
  },
  setup() {
    const email = ref('');
    const {
      app: { i18n },
    } = useContext();
    const { updateSubscription, error } = useNewsletter();
    const { send: sendNotification } = useUiNotification();

    const handleSubscribe = async () => {
      if (email.value && email.value) {
        const result = await updateSubscription({ email: email.value });
        if (error.value.updateSubscription) {
          sendNotification({
            id: Symbol('subscribed_sucess'),
            message: error.value.updateSubscription.message,
            persist: false,
            type: 'success',
            icon: 'check',
            title: 'congratulations',
          });
          return;
        }
        if (result === 'SUBSCRIBED') {
          sendNotification({
            id: Symbol('subscribed_sucess'),
            message: i18n.t(
              'You have been successfully subscribed to our newsletter!'
            ) as string,
            persist: false,
            type: 'success',
            icon: 'check',
            title: 'congratulations',
          });
        }
      } else {
        sendNotification({
          id: Symbol('error_subscribed_email'),
          message: i18n.t('please enter email address!') as string,
          persist: false,
          type: 'danger',
          icon: 'error',
          title: 'congratulations',
        });
      }
    };
    return {
      email,
      handleSubscribe,
    };
  },
});
